import gql from 'graphql-tag';

export default gql`
    mutation AddJob($input: AddJobInput) {
        addJob(input: $input) {
            errors
            createdJobId
        }
    }
`;
